<template>
  <form class="job-search container container-primary my-15 px-0" @submit="onSubmitForSearchJob">
    <div
      v-if="saveJobSearchResult == 'limited'"
      class="alert alert-success alert-dismissible fade show text-danger"
      role="alert"
    >
      保存できる条件の上限（10件）に達しています
      <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
    </div>
    <div
      v-if="saveJobSearchResult == 'success'"
      class="alert alert-success alert-dismissible fade show"
      role="alert"
    >
      更新が正常に完了しました。
      <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
    </div>
    <div
      v-if="saveJobSearchResult == 'fail'"
      class="alert alert-danger alert-dismissible fade show"
      role="alert"
    >
      更新が中断されました。
      <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
    </div>
    <div class="bg-blue-primary d-md-flex justify-content-center d-none">
      <p class="m-2 text-white">検索条件</p>
    </div>
    <div class="search-job__body bg-white-primary py-4 mx-md-0">
      <a
        v-if="!authStore.isAuthenticated"
        :href="`/candidate/login`"
        class="d-flex justify-content-center my-2 text-decoration-none"
      >
        <img src="@/assets/images/icons/menu.svg" class="me-2" />
        <span class="size-12 fw-medium color-blue-primary">保存した検索条件</span>
      </a>
      <div
        v-else
        class="d-flex justify-content-center my-2"
        data-bs-toggle="modal"
        data-bs-target="#modalListConditionSearchAgentElement"
      >
        <img src="@/assets/images/icons/menu.svg" class="me-2" />
        <span class="size-12 fw-medium color-blue-primary">保存した検索条件</span>
      </div>

      <!-- Occupation -->
      <Occupation
        :occupations="occupationSelected"
        @open="onOpenModalOccupation"
        @remove="onRemoveOccupation"
      />
      <hr class="color-grey-primary opacity-100" />

      <!-- Prefecture -->
      <DesiredJob
        :prefectures="prefectureSelected"
        @open="onOpenModalPrefecture"
        @remove="onRemovePrefecture"
      />
      <hr class="color-grey-primary opacity-100" />

      <!-- annual-income -->
      <AnnualIncome
        :min-income="minIncomeSelected"
        :max-income="maxIncomeSelected"
        :incomes="props.incomes"
        @change-min="onChangeMinIncome"
        @change-max="onChangeMaxIncome"
      />
      <hr class="color-grey-primary opacity-100" />

      <!-- Industry -->
      <Industry
        :industries="industriesSelected"
        @open="onOpenModalIndustry"
        @remove="onRemoveIndustry"
      />
      <hr class="color-grey-primary opacity-100" />

      <!-- Skill -->
      <Skill :skills="skillSelected" @open="onOpenModalSkill" @remove="onRemoveSkill" />
      <hr class="color-grey-primary opacity-100" />

      <!-- Search word -->
      <div class="row justify-content-start px-3">
        <span class="form-label align-self-start size-12">フリーワード</span>
        <div>
          <input
            v-model="searchWord"
            type="text"
            name="search_word"
            class="form-control me-3 size-14 bg-silver-primary input-primary"
            placeholder="例）○○○"
            @keydown.enter.prevent="search"
          />
        </div>
      </div>
      <hr class="color-grey-primary opacity-100" />

      <div class="job-search__footer pt-2 mt-4 row pb-4r justify-content-center mb-a4">
        <div class="row text-center">
          <p class="size-12 fw-bold">
            この条件の求人数
            <span class="size-20 px-2">
              <vue3-autocounter
                ref="counter"
                :start-amount="0"
                :end-amount="resultSearch"
                :duration="1"
                :autoinit="true"
                @finished=""
              />
            </span>
            <span>件</span>
          </p>
        </div>
        <div class="d-flex justify-content-center">
          <button
            type="button"
            class="justify-content-center d-flex align-items-center h-48x w-285x btn btn-primary py-3 size-12 col-12 col-md-9"
            data-bs-dismiss="modal"
            @click="() => onChangeResultSearch()"
          >
            この条件で検索
          </button>
        </div>

        <div class="d-flex justify-content-center mt-3">
          <div
            id="save-job-available"
            :class="props.totalConditionSearch < 10 ? 'd-block' : 'd-none'"
          >
            <button
              type="button"
              class="justify-content-center d-flex align-items-center h-48x w-285x btn btn-outline-secondary rounded-24 py-3 size-12 col-12 col-md-9"
              @click="onOpenModalSaveJobCondition"
            >
              この条件を保存
            </button>
          </div>
          <div
            id="save-job-unavailable"
            :class="props.totalConditionSearch < 10 ? 'd-none' : 'd-block'"
          >
            <button
              type="button"
              class="justify-content-center d-flex align-items-center h-48x w-285x btn btn-outline-secondary rounded-24 py-3 size-12 col-12 col-md-9 disabled"
            >
              この条件を保存
            </button>
            <p class="text-danger size-12 text-center">
              保存できる条件の上限（10件）に達しています
            </p>
          </div>
        </div>

        <!-- Clear condition -->
        <div class="text-center mt-2 mw-100 h-46x d-flex justify-content-center align-items-center">
          <button
            type="button"
            class="btn btn-link color-blue-primary text-decoration-none size-12"
            @click="onClearConditionSearch"
          >
            <img src="@/assets/images/icons/ic-remove.svg" alt="Group icon" class="mb-2x" />
            条件をクリア
          </button>
        </div>
      </div>
    </div>
  </form>

  <ModalBase
    ref="modalSaveJobConditionSP"
    is-show-add-button
    element="modalSaveJobConditionElementSP"
  >
    <template #body>
      <div class="d-flex justify-content-center p-0">
        <p class="m-2 fw-bold size-16">検索条件を保存</p>
      </div>
      <div class="row mx-3 justify-content-start px-3">
        <span class="form-label align-self-start size-12">検索条件名</span>
        <input
          v-model="title"
          type="text"
          name="title"
          class="form-control size-14 border-0 bg-silver-primary input-primary"
        />
        <div class="d-flex justify-content-end counter text-black-50 size-10 mt-2">
          文字数： {{ title?.length }}
        </div>
      </div>
      <div class="h-48x d-flex justify-content-center my-4">
        <button
          type="button"
          class="align-items-center justify-content-center d-flex h-48x w-285x btn btn-primary rounded-24 py-3 size-12"
          data-bs-dismiss="modal"
          @click="onSubmitForSearchJob"
        >
          この条件を保存
        </button>
      </div>
    </template>
  </ModalBase>

  <ModalBase
    ref="modalOccupationsSP"
    :data="props.occupations.length"
    is-show-scroll-button
    class="bg-red"
    element="modalOccupationsElementSP"
    title="職種を選ぶ"
    @addItems="addOccupations"
  >
    <template #body>
      <div id="occupation-accordion" class="accordion accordion-primary">
        <div
          v-for="occupation in props.occupations"
          :key="occupation.id"
          class="accordion-item border-top-0 rounded-0"
        >
          <h4 class="accordion-header px-3 py-2">
            <span
              class="text-decoration-none size-14 bg-white pe-1 d-flex align-items-center w-100"
            >
              <input
                :id="`occupation-item-input-${occupation.id}`"
                type="checkbox"
                class="form-check-input collapsed checkbox-primary-input w-1d5 h-1d5 mt-0"
                :checked="valuesOccupations.some((item) => item.id == occupation.id)"
                @change="onChooseOccupationCategory(occupation)"
              />
              <label
                class="form-check-label size-14 ms-3"
                @click="onChooseOccupationCategory(occupation)"
              >
                {{ occupation.name }}
              </label>
              <div
                class="accordion-button collapsed d-contents"
                data-bs-toggle="collapse"
                :data-bs-target="`#occupation-item-${occupation.id}-search-sp`"
                aria-expanded="true"
                :aria-controls="`occupation-item-${occupation.id}-search-sp`"
              ></div>
            </span>
          </h4>
          <div
            :id="`occupation-item-${occupation.id}-search-sp`"
            class="row mx-2 my-2 pe-0 accordion-collapse collapse"
          >
            <div
              v-for="(children, index) in occupation.children"
              :key="children.id"
              class="accordion-body ps-4 pe-3 py-2 border-bottom"
              :class="{ 'border-top': index == 0 }"
              :aria-labelledby="`occupation-${occupation.id}`"
            >
              <input
                :id="`occupation-item-input-${children.id}`"
                type="checkbox"
                class="form-check-input checkbox-primary-input w-1d5 h-1d5"
                :checked="
                  valuesOccupations.some((item) => item.children.some((c) => c.id == children.id))
                "
                @click="onChooseOccupation(occupation, children)"
              />
              <label
                class="form-check-label size-14 ms-3"
                :for="`occupation-item-input-${children.id}`"
                @click="onChooseOccupation(occupation, children)"
              >
                {{ children.name }}
              </label>
            </div>
          </div>
        </div>
      </div>
    </template>
  </ModalBase>

  <ModalBase
    ref="modalPrefectureSP"
    :data="props.prefectures.length"
    is-show-scroll-button
    element="modalPrefectureElementSP"
    title="勤務地を選ぶ"
    @addItems="addPrefectures"
  >
    <template #body>
      <div id="prefecture-accordion" class="accordion accordion-primary">
        <div v-for="prefecture in props.prefectures" :key="prefecture.id" class="accordion-item">
          <h4 :id="`prefecture-${prefecture.id}`" class="accordion-header">
            <a
              class="collapsed rounded-0 bg-white accordion-button ps-3 size-14 text-decoration-none"
              data-bs-toggle="collapse"
              :data-bs-target="`#prefecture-item-${prefecture.id}`"
              aria-expanded="true"
              :aria-controls="`prefecture-item-${prefecture.id}`"
            >
              {{ prefecture.name }}
            </a>
          </h4>
          <div :id="`prefecture-item-${prefecture.id}`" class="accordion-collapse collapse">
            <div class="accordion-body p-0">
              <div class="accordion accordion-primary">
                <div
                  v-for="children in prefecture.children"
                  :key="children.id"
                  class="accordion-item border-top-0 rounded-0"
                >
                  <h4 class="accordion-header px-3 py-2">
                    <span
                      class="text-decoration-none size-14 bg-white ps-3 pe-1 d-flex align-items-center w-100"
                    >
                      <input
                        :id="`prefecture-item-input-${prefecture.id}-children-${children.id}`"
                        type="checkbox"
                        class="form-check-input collapsed checkbox-primary-input w-1d5 h-1d5 mt-0"
                        :checked="valuesPrefectures.some((item) => item.id == children.id)"
                        @change="onChangePrefecture(children)"
                      />
                      <label
                        class="form-check-label size-14 ms-3"
                        @click="onChangePrefecture(children)"
                      >
                        {{ children.name }}
                      </label>
                    </span>
                  </h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </ModalBase>

  <ModalBase
    ref="modalIndustrySP"
    is-show-scroll-button
    element="modalIndustryElementSP"
    title="業種を選ぶ"
    @addItems="addIndustries"
  >
    <template #body>
      <div id="industry-accordion" class="accordion accordion-primary">
        <div
          v-for="industry in props.industries"
          :key="industry.id"
          class="accordion-item border-top-0 rounded-0"
        >
          <h4 class="accordion-header px-3 py-2">
            <span
              class="text-decoration-none size-14 bg-white pe-1 d-flex align-items-center w-100"
            >
              <input
                :id="`industry-item-input-${industry.id}`"
                type="checkbox"
                class="form-check-input collapsed checkbox-primary-input w-1d5 h-1d5 mt-0"
                :checked="valuesIndustries.some((item) => item.id == industry.id)"
                @change="onChooseIndustryCategory(industry)"
              />
              <label
                class="form-check-label size-14 ms-3"
                @click="onChooseIndustryCategory(industry)"
              >
                {{ industry.name }}
              </label>
              <div
                class="accordion-button collapsed d-contents"
                data-bs-toggle="collapse"
                :data-bs-target="`#industry-item-${industry.id}-search-sp`"
                aria-expanded="true"
                :aria-controls="`industry-item-${industry.id}-search-sp`"
              ></div>
            </span>
          </h4>
          <div :id="`industry-item-${industry.id}-search-sp`" class="accordion-body p-0 collapse">
            <div
              v-for="(children, index) in industry.children"
              :key="children.id"
              class="ps-4 pe-3 py-2 border-bottom"
              :class="{ 'border-top': index == 0 }"
            >
              <input
                :id="`industry-item-input-${children.id}`"
                type="checkbox"
                class="form-check-input checkbox-primary-input w-1d5 h-1d5"
                :checked="
                  valuesIndustries.some((item) => item.children.some((c) => c.id == children.id))
                "
                @click="onChooseIndustry(industry, children)"
              />
              <label
                class="form-check-label size-14 ms-3"
                :for="`industry-item-input-${children.id}`"
              >
                {{ children.name }}
              </label>
            </div>
          </div>
        </div>
      </div>
    </template>
  </ModalBase>

  <ModalBase
    ref="modalSkillsSP"
    is-show-scroll-button
    element="modalSkillsElementSP"
    title="スキルを選ぶ"
    @addItems="addSkills"
  >
    <template #body>
      <div id="skill-accordion" class="accordion accordion-primary">
        <div
          v-for="skill in props.skills"
          :key="skill.id"
          class="accordion-item border-top-0 rounded-0"
        >
          <h4 class="accordion-header px-3 py-2">
            <span
              class="text-decoration-none size-14 bg-white pe-1 d-flex align-items-center w-100"
            >
              <input
                :id="`skill-item-input-${skill.id}`"
                type="checkbox"
                class="form-check-input collapsed checkbox-primary-input w-1d5 h-1d5 mt-0"
                :checked="valueSkills.some((item) => item.id == skill.id)"
                @change="onChooseSkillCategory(skill)"
              />
              <label class="form-check-label size-14 ms-3" @click="onChooseSkillCategory(skill)">
                {{ skill.name }}
              </label>
              <div
                class="accordion-button collapsed d-contents"
                data-bs-toggle="collapse"
                :data-bs-target="`#skill-item-${skill.id}-search-sp`"
                aria-expanded="true"
                :aria-controls="`skill-item-${skill.id}-search-sp`"
              ></div>
            </span>
          </h4>
          <div :id="`skill-item-${skill.id}-search-sp`" class="accordion-body p-0 collapse">
            <div
              v-for="(children, index) in skill.children"
              :key="children.id"
              class="ps-4 pe-3 py-2 border-bottom"
              :class="{ 'border-top': index == 0 }"
            >
              <input
                :id="`skill-item-input-${children.id}`"
                type="checkbox"
                class="form-check-input checkbox-primary-input w-1d5 h-1d5"
                :checked="
                  valueSkills.some((item) => item.children.some((c) => c.id == children.id))
                "
                @click="onChooseSkill(skill, children)"
              />
              <label class="form-check-label size-14 ms-3" :for="`skill-item-input-${children.id}`">
                {{ children.name }}
              </label>
            </div>
          </div>
        </div>
      </div>
    </template>
  </ModalBase>
</template>

<script setup lang="ts">
import _ from 'lodash';
import { onMounted, ref, PropType, defineProps } from 'vue';
import { Collapse } from 'bootstrap';
import ModalBase from '@/components/common/ModalBase/index.vue';
import Occupation from '@/components/JobSearch/Occupation.vue';
import DesiredJob from '@/components/JobSearch/DesiredJob.vue';
import AnnualIncome from '@/components/JobSearch/AnnualIncome.vue';
import Industry from '@/components/JobSearch/Industry.vue';
import Skill from '@/components/JobSearch/Skill.vue';
import { OccupationPrimary, OccupationThirdary } from '@/types/models/occupation';
import {
  PrefectureFourth,
  PrefecturePrimary,
  PrefectureSecondary,
} from '@/types/models/prefecture';
import { IndustryType } from '@/types/models/industryType';
import { SkillsType } from '@/types/models/skill';
import { IncomePrimary } from '@/types/models/income';
import { cloneDeep } from 'lodash';
import Vue3Autocounter from 'vue3-autocounter';
import { getAgentJobs } from '@/apis/job.api';
import { saveJobSearchCondition } from '@/apis/candidate';
import { CANDIDATE_LOGIN_PATH, AGENT_SEARCH_PATH } from '@/constant/routers/path';
import { useRoute } from 'vue-router';

import router from '@/routers';
import { useAuthStore } from '@/stores/auth.store';

const valuesPrefectures = ref<PrefecturePrimary[]>([]);
const valuesOccupations = ref<OccupationThirdary[]>([]);
const valuesIndustries = ref<IndustryType[]>([]);
const valueSkills = ref<SkillsType[]>([]);

const title = ref<string | null>(null);
const saveJobSearchResult = ref<string | null>(null);
const perPage = 30;
const searchWord = ref<string | null>(null);

const prefectureSelected = ref<PrefectureFourth[]>([]);
const occupationSelected = ref<OccupationThirdary[]>([]);
const industriesSelected = ref<IndustryType[]>([]);
const skillSelected = ref<SkillsType[]>([]);
const minIncomeSelected = ref<number | null>(null);
const maxIncomeSelected = ref<number | null>(null);

const modalPrefectureSP = ref<InstanceType<typeof ModalBase> | null>(null);
const modalOccupationsSP = ref<InstanceType<typeof ModalBase> | null>(null);
const modalIndustrySP = ref<InstanceType<typeof ModalBase> | null>(null);
const modalSkillsSP = ref<InstanceType<typeof ModalBase> | null>(null);
const modalSaveJobConditionSP = ref<InstanceType<typeof ModalBase> | null>(null);

const route = useRoute();
const authStore = useAuthStore();
const resultSearch = ref(0);

onMounted(async () => {
  title.value = getCurrentDate();
  resultSearch.value = props.initialTotalResult;
  authStore.checkAuthenticated();
  await getParamSearch();
});

const getCurrentDate = (): string => {
  const currentDate = new Date();
  const month = String(currentDate.getMonth() + 1).padStart(2, '0');
  const day = String(currentDate.getDate()).padStart(2, '0');
  const time =
    String(currentDate.getHours()).padStart(2, '0') +
    ':' +
    String(currentDate.getMinutes()).padStart(2, '0') +
    ':' +
    String(currentDate.getSeconds()).padStart(2, '0');

  return currentDate.getFullYear() + '/' + month + '/' + day + ' ' + time;
};

const onOpenModalSaveJobCondition = (): void => {
  modalSaveJobConditionSP?.value?.onOpen();
};

const onOpenModalOccupation = (): void => {
  modalOccupationsSP?.value?.onOpen();
};

const addOccupations = (): void => {
  occupationSelected.value = cloneDeep(valuesOccupations.value);
  search();
};

const onChooseOccupationCategory = (occupationCategory: OccupationThirdary): void => {
  const isCurrentlySelected = valuesOccupations.value.some(
    (item) => item.id === occupationCategory.id
  );

  if (!isCurrentlySelected) {
    const newOccupation = {
      id: occupationCategory.id,
      name: occupationCategory.name,
      children: [],
    };

    occupationCategory.children.forEach((child) => {
      newOccupation.children.push({
        id: child.id,
        name: child.name,
      });
    });

    valuesOccupations.value.push(newOccupation);
  } else {
    const index = valuesOccupations.value.findIndex((item) => item.id === occupationCategory.id);
    if (index !== -1) {
      valuesOccupations.value.splice(index, 1);
    }
  }

  const accordionId = `occupation-item-${occupationCategory.id}-search-sp`;
  const accordionElement = document.getElementById(accordionId);
  if (accordionElement) {
    const collapse = Collapse.getInstance(accordionElement) || new Collapse(accordionElement);
    if (!accordionElement.classList.contains('show')) {
      collapse.show();
    }
  }
};

const onChooseOccupation = (
  occupationCategory: OccupationThirdary,
  occupation: OccupationThirdary
): void => {
  if (_.find(valuesOccupations.value, { id: occupationCategory.id })) {
    selectedOccupation(occupationCategory, occupation);
  } else {
    valuesOccupations.value.push({
      id: occupationCategory.id,
      name: occupationCategory.name,
      children: [],
    });
    selectedOccupation(occupationCategory, occupation);
  }
};

const selectedOccupation = (
  occupationCategory: OccupationThirdary,
  occupation: OccupationThirdary
): void => {
  const occupationCategoryEntry = _.find(valuesOccupations.value, { id: occupationCategory.id });
  if (occupationCategoryEntry) {
    if (_.find(occupationCategoryEntry.children, { id: occupation.id })) {
      occupationCategoryEntry.children = _.reject(occupationCategoryEntry.children, {
        id: occupation.id,
      });
    } else {
      occupationCategoryEntry.children.push(occupation);
    }

    if (occupationCategoryEntry.children.length === 0) {
      valuesOccupations.value = _.reject(valuesOccupations.value, { id: occupationCategory.id });

      _.forEach(props.occupations, (item) => {
        if (item.id === occupationCategory.id) {
          item.selected = false;
        }
      });
    }
  }
};

const onRemoveOccupation = (occupationId: number): void => {
  valuesOccupations.value = valuesOccupations.value
    .map((item) => ({
      ...item,
      children: item.children.filter((child) => child.id !== occupationId),
    }))
    .filter((item) => item.children.length > 0);
  occupationSelected.value = cloneDeep(valuesOccupations.value);
  search();
};

const onOpenModalPrefecture = (): void => {
  modalPrefectureSP?.value?.onOpen();
};

const onChangePrefecture = (prefecture: PrefectureSecondary): void => {
  let checked = false;
  if (valuesPrefectures.value.find((item) => item.id == prefecture.id)) {
    valuesPrefectures.value = valuesPrefectures.value.filter((item) => prefecture.id !== item.id);
  } else {
    checked = true;
    valuesPrefectures.value.push({ id: prefecture.id, name: prefecture.name, cities: [] });
  }

  props.prefectures.map((item) => {
    item.children?.map((child) => {
      if (child.id == prefecture.id) {
        child.selected = checked;
      }
    });
  });
};

const onRemovePrefecture = (prefectureId: number): void => {
  valuesPrefectures.value = valuesPrefectures.value.filter((item) => {
    return item.id != prefectureId;
  });
  prefectureSelected.value = cloneDeep(valuesPrefectures.value);
  search();
};

const addPrefectures = (): void => {
  prefectureSelected.value = cloneDeep(valuesPrefectures.value);
  search();
};

const onChangeMinIncome = (minIncome: { value: number | null }): void => {
  minIncomeSelected.value = minIncome.value;
  search();
};

const onChangeMaxIncome = (maxIncome: { value: number | null }): void => {
  maxIncomeSelected.value = maxIncome.value;
  search();
};

const onOpenModalIndustry = (): void => {
  modalIndustrySP?.value?.onOpen();
};

const onChooseIndustryCategory = (industryCategory: IndustryType): void => {
  const isCurrentlySelected = valuesIndustries.value.some(
    (item) => item.id === industryCategory.id
  );

  if (!isCurrentlySelected) {
    const newIndustry = {
      id: industryCategory.id,
      name: industryCategory.name,
      children: [],
    };

    industryCategory.children.forEach((child) => {
      newIndustry.children.push({
        id: child.id,
        name: child.name,
      });
    });

    valuesIndustries.value.push(newIndustry);
  } else {
    const index = valuesIndustries.value.findIndex((item) => item.id === industryCategory.id);
    if (index !== -1) {
      valuesIndustries.value.splice(index, 1);
    }
  }

  const accordionId = `industry-item-${industryCategory.id}-search-sp`;
  const accordionElement = document.getElementById(accordionId);
  if (accordionElement) {
    const collapse = Collapse.getInstance(accordionElement) || new Collapse(accordionElement);
    if (!accordionElement.classList.contains('show')) {
      collapse.show();
    }
  }
};

const onChooseIndustry = (industryCategory: IndustryType, industry: IndustryType): void => {
  if (_.find(valuesIndustries.value, { id: industryCategory.id })) {
    selectedIndustry(industryCategory, industry);
  } else {
    valuesIndustries.value.push({
      id: industryCategory.id,
      name: industryCategory.name,
      children: [],
    });
    selectedIndustry(industryCategory, industry);
  }
};

const selectedIndustry = (industryCategory: IndustryType, industry: IndustryType): void => {
  const industryCategoryEntry = _.find(valuesIndustries.value, { id: industryCategory.id });
  if (industryCategoryEntry) {
    if (_.find(industryCategoryEntry.children, { id: industry.id })) {
      industryCategoryEntry.children = _.reject(industryCategoryEntry.children, {
        id: industry.id,
      });
    } else {
      industryCategoryEntry.children.push(industry);
    }

    if (industryCategoryEntry.children.length === 0) {
      valuesIndustries.value = _.reject(valuesIndustries.value, { id: industryCategory.id });

      _.forEach(props.industries, (item) => {
        if (item.id === industryCategory.id) {
          item.selected = false;
        }
      });
    }
  }
};

const onRemoveIndustry = (industryId: number): void => {
  valuesIndustries.value = valuesIndustries.value
    .map((item) => ({
      ...item,
      children: item.children.filter((child) => child.id !== industryId),
    }))
    .filter((item) => item.children.length > 0);
  industriesSelected.value = cloneDeep(valuesIndustries.value);
  search();
};

const addIndustries = (): void => {
  industriesSelected.value = cloneDeep(valuesIndustries.value);
  search();
};

const onOpenModalSkill = (): void => {
  modalSkillsSP?.value?.onOpen();
};

const onChooseSkillCategory = (skillCategory: SkillsType): void => {
  const isCurrentlySelected = valueSkills.value.some((item) => item.id === skillCategory.id);

  if (!isCurrentlySelected) {
    const newSkill = {
      id: skillCategory.id,
      name: skillCategory.name,
      children: [],
    };

    skillCategory.children.forEach((child) => {
      newSkill.children.push({
        id: child.id,
        name: child.name,
      });
    });

    valueSkills.value.push(newSkill);
  } else {
    const index = valueSkills.value.findIndex((item) => item.id === skillCategory.id);
    if (index !== -1) {
      valueSkills.value.splice(index, 1);
    }
  }

  const accordionId = `skill-item-${skillCategory.id}-search-sp`;
  const accordionElement = document.getElementById(accordionId);
  if (accordionElement) {
    const collapse = Collapse.getInstance(accordionElement) || new Collapse(accordionElement);
    if (!accordionElement.classList.contains('show')) {
      collapse.show();
    }
  }
};

const onChooseSkill = (skillCategory: SkillsType, skill: SkillsType): void => {
  if (_.find(valueSkills.value, { id: skillCategory.id })) {
    selectedSkill(skillCategory, skill);
  } else {
    valueSkills.value.push({ id: skillCategory.id, name: skillCategory.name, children: [] });
    selectedSkill(skillCategory, skill);
  }
};

const selectedSkill = (skillCategory: SkillsType, skill: SkillsType): void => {
  const skillCategoryEntry = _.find(valueSkills.value, { id: skillCategory.id });
  if (skillCategoryEntry) {
    if (_.find(skillCategoryEntry.children, { id: skill.id })) {
      skillCategoryEntry.children = _.reject(skillCategoryEntry.children, { id: skill.id });
    } else {
      skillCategoryEntry.children.push(skill);
    }

    if (skillCategoryEntry.children.length === 0) {
      valueSkills.value = _.reject(valueSkills.value, { id: skillCategory.id });

      _.forEach(props.skills, (item) => {
        if (item.id === skillCategory.id) {
          item.selected = false;
        }
      });
    }
  }
};

const onRemoveSkill = (skillId: number): void => {
  valueSkills.value = valueSkills.value
    .map((item) => ({ ...item, children: item.children.filter((child) => child.id !== skillId) }))
    .filter((item) => item.children.length > 0);
  skillSelected.value = cloneDeep(valueSkills.value);
  search();
};

const addSkills = (): void => {
  skillSelected.value = cloneDeep(valueSkills.value);
  search();
};

const initialValuesConditionSearch = (): void => {
  searchWord.value = '';
  prefectureSelected.value = [];
  valuesPrefectures.value = [];
  occupationSelected.value = [];
  valuesOccupations.value = [];
  industriesSelected.value = [];
  valuesIndustries.value = [];
  skillSelected.value = [];
  valueSkills.value = [];
  minIncomeSelected.value = null;
  maxIncomeSelected.value = null;
};

const onClearConditionSearch = (): void => {
  initialValuesConditionSearch();
  search();
};

// !!!実際の挙動と関数名が逆
// onChangeResultSearchは、検索実行時に呼ばれる
// searchは、検索条件変更時に呼ばれる
const onChangeResultSearch = async (): Promise<void> => {
  const minIncome = props.incomes.find((income) => income.id === minIncomeSelected.value);
  const maxIncome = props.incomes.find((income) => income.id === maxIncomeSelected.value);

  const data = {
    keywords: searchWord.value,
    occupations: occupationSelected.value.flatMap((item) => item.children.map((c) => c.id)),
    locations: prefectureSelected.value.map((item) => item.id),
    annual_min_income: minIncome?.display_amount ? getNumberIncome(minIncome.display_amount) : null,
    annual_max_income: maxIncome?.display_amount ? getNumberIncome(maxIncome.display_amount) : null,
    industries: industriesSelected.value.flatMap((item) => item.children.map((c) => c.id)),
    skills: skillSelected.value.flatMap((item) => item.children.map((c) => c.id)),
    sort_by: props.sort,
  };
  const params: Record<string, any> = {
    include: [
      'corporation',
      'prefectures',
      'hrc_skills',
      'hrc_job_types',
      'corporation.corporation_industries',
    ],
    'filter[have_hrc_job_types_any]': data.occupations,
    'filter[with_prefecture]': data.locations,
    'filter[have_corporation_industries_any]': data.industries,
    'filter[have_hrc_skills_any]': data.skills,
    'filter[contain_keywords_any]': data.keywords?.trim().split(/[\s　]+/) || [], // Split whitespace full-width or half-width
    sort: '-' + data.sort_by,
    'page[size]': perPage,
    'page[number]': undefined,
  };
  if (data.annual_min_income || data.annual_max_income) {
    params['filter[with_wage_range]'] = [data.annual_min_income, data.annual_max_income];
  }
  const response = await getAgentJobs(params);
  resultSearch.value = response.data.meta.total_records;
  emit('searchJob', response, data);
  if (window.scrollY > 0) window.scrollTo(0, 0);
  const page = Math.max(Number(route.query.page) || 1, 1);
  const paramsData = {
    keywords: searchWord.value || undefined,
    job_types: occupationSelected.value.flatMap((item) => item.children.map((c) => c.id)),
    prefectures: prefectureSelected.value?.map((item) => item.id),
    city_ids: prefectureSelected.value.flatMap((item) => item.cities.map(({ id }) => id)),
    wage_min: minIncomeSelected.value || undefined,
    wage_max: maxIncomeSelected.value || undefined,
    industries: industriesSelected.value?.flatMap((item) => item.children.map((c) => c.id)),
    skills: skillSelected.value?.flatMap((item) => item.children.map((c) => c.id)),
    agent: true,
    page: page === 1 ? undefined : page,
  };
  router.push({ path: AGENT_SEARCH_PATH, query: { ...route.params, ...paramsData } });
};

const onSubmitForSearchJob = async (): Promise<void> => {
  await emit('getListConditionSearch');
  if (props.totalConditionSearch > 10) {
    setTimeout(() => {
      saveJobSearchResult.value = '';
    }, 3000);
    return (saveJobSearchResult.value = 'limited');
  }
  const conditionSearchLocations: any[] = [];
  prefectureSelected.value.forEach((item) => {
    if (item.cities.length <= 0) return conditionSearchLocations.push({ prefecture_id: item.id });
    item.cities.forEach((city) =>
      conditionSearchLocations.push({ prefecture_id: item.id, city_id: city.id })
    );
  });
  event?.preventDefault();
  const data = {
    platform: true,
    title: title.value || getCurrentDate(),
    keywords: searchWord.value,
    occupations: occupationSelected.value.flatMap((item) => item.children.map((c) => c.id)),
    locations: conditionSearchLocations,
    annual_min_income_id: minIncomeSelected.value,
    annual_max_income_id: maxIncomeSelected.value,
    industries: industriesSelected.value.flatMap((item) => item.children.map((c) => c.id)),
    skills: skillSelected.value.flatMap((item) => item.children.map((c) => c.id)),
  };
  const response = await saveJobSearchCondition(data);
  if (response.status === 200) {
    emit('createJobCondition');
    setTimeout(() => {
      saveJobSearchResult.value = '';
    }, 3000);
    saveJobSearchResult.value = 'success';
    emit('getListConditionSearch');
  } else {
    if (response.status === 401) {
      window.location.href = CANDIDATE_LOGIN_PATH;
    } else {
      emit('createJobCondition');
      setTimeout(() => {
        saveJobSearchResult.value = '';
      }, 3000);
      saveJobSearchResult.value = 'fail';
      emit('getListConditionSearch');
    }
  }
};

const onApplySearchCondition = (searchCondition: any): void => {
  initialValuesConditionSearch();
  title.value = searchCondition?.title;
  searchWord.value = searchCondition?.candidate_saved_job_search_condition_freeword?.free_word;
  searchCondition.candidate_saved_job_search_condition_occupations.forEach((item) => {
    props.occupations.forEach((occupation) => {
      const occupationChild = occupation.children.find((child) => child.id === item.occupation_id);

      if (occupationChild) {
        onChooseOccupation(occupation, occupationChild);
        occupationSelected.value = cloneDeep(valuesOccupations.value);
      }
    });
  });
  const prefectureIds = [
    ...new Set(
      searchCondition.candidate_saved_job_search_condition_locations.map(
        (item) => item.prefecture_id
      )
    ),
  ];
  const cityIds = [
    ...new Set(
      searchCondition.candidate_saved_job_search_condition_locations.map((item) => item.city_id)
    ),
  ];
  prefectureIds.forEach((id) => {
    const prefecture = props.prefectures.find((prefecture) =>
      prefecture.children.some((child) => child.id === id)
    );
    if (prefecture) {
      const prefectureChild = prefecture.children.find((child) => child.id === id);
      const cities = [];

      cityIds
        .filter((item) => item !== null)
        .forEach((cityId) => {
          const matchingCity = [
            ...prefectureChild.main_cities,
            ...prefectureChild.extra_cities,
          ].find((city) => city.id === cityId);

          if (matchingCity) {
            cities.push(matchingCity);
          }
        });

      valuesPrefectures.value.push({
        id: prefectureChild.id,
        name: prefectureChild.name,
        cities: cities,
      });
      prefectureSelected.value = cloneDeep(valuesPrefectures.value);
    }
  });
  minIncomeSelected.value = searchCondition.annual_min_income_id;
  maxIncomeSelected.value = searchCondition.annual_max_income_id;
  searchCondition.candidate_saved_job_search_condition_industries.forEach((item) => {
    props.industries.forEach((industry) => {
      const industryChild = industry.children?.find((child) => child.id === item.industry_id);

      if (industryChild) {
        onChooseIndustry(industry, industryChild);
        industriesSelected.value = cloneDeep(valuesIndustries.value);
      }
    });
  });
  searchCondition.candidate_saved_job_search_condition_skills.forEach((item) => {
    props.skills.forEach((skill) => {
      const skillChild = skill.children.find((child) => child.id === item.skill_id);

      if (skillChild) {
        onChooseSkill(skill, skillChild);
        skillSelected.value = cloneDeep(valueSkills.value);
      }
    });
  });
  search();
  onChangeResultSearch();
};

const emit = defineEmits(['searchJob', 'createJobCondition', 'getListConditionSearch']);

const props = defineProps({
  prefectures: {
    type: Array as PropType<PrefecturePrimary[]>,
    required: true,
  },
  occupations: {
    type: Array as PropType<OccupationPrimary[]>,
    required: true,
  },
  industries: {
    type: Array as PropType<IndustryType[]>,
    required: true,
  },
  skills: {
    type: Array as PropType<SkillsType[]>,
    required: true,
  },
  sort: {
    type: String,
    required: true,
  },
  incomes: {
    type: Array as PropType<IncomePrimary[]>,
    required: true,
  },
  totalConditionSearch: {
    type: Number,
    required: true,
  },
  initialTotalResult: {
    type: Number,
    required: true,
  },
});

// !!!実際の挙動と関数名が逆
// onChangeResultSearchは、検索実行時に呼ばれる
// searchは、検索条件変更時に呼ばれる
const search = async (): Promise<void> => {
  const minIncome = props.incomes.find((income) => income.id === minIncomeSelected.value);
  const maxIncome = props.incomes.find((income) => income.id === maxIncomeSelected.value);

  const data = {
    keywords: searchWord.value,
    occupations: occupationSelected.value.flatMap((item) => item.children.map((c) => c.id)),
    locations: prefectureSelected.value.map((item) => item.id),
    annual_min_income: minIncome?.display_amount ? getNumberIncome(minIncome.display_amount) : null,
    annual_max_income: maxIncome?.display_amount ? getNumberIncome(maxIncome.display_amount) : null,
    industries: industriesSelected.value.flatMap((item) => item.children.map((c) => c.id)),
    skills: skillSelected.value.flatMap((item) => item.children.map((c) => c.id)),
  };

  const params: Record<string, any> = {
    'page[size]': 0, // カウント取得時はデータ本体を取得しない
    'page[number]': 1,
    include: [
      'corporation',
      'prefectures',
      'hrc_skills',
      'hrc_job_types',
      'corporation.corporation_industries',
    ],
    'filter[have_hrc_job_types_any]': data.occupations,
    'filter[with_prefecture]': data.locations,
    'filter[have_corporation_industries_any]': data.industries,
    'filter[have_hrc_skills_any]': data.skills,
    'filter[contain_keywords_any]': data.keywords?.trim().split(/[\s　]+/) || [], // Split whitespace full-width or half-width
  };
  if (data.annual_min_income || data.annual_max_income) {
    params['filter[with_wage_range]'] = [data.annual_min_income, data.annual_max_income];
  }
  const response = await getAgentJobs(params);
  // レスポンス受信後にpage[size]とpage[number]を削除
  delete params['page[size]'];
  delete params['page[number]'];
  resultSearch.value = response.data.meta.total_records;
};

const getParamSearch = async (): Promise<void> => {
  if (Object.keys(route.query).length === 0) return search();
  initialValuesConditionSearch();
  searchWord.value = route.query.keywords || null;
  title.value = route.query.title || getCurrentDate();
  getOccupations();
  getDesireLocation();
  getAnnualIncome();
  getIndustries();
  getSkills();
};

const getDesireLocation = (): void => {
  if (route.query.prefectures || route.query['prefectures[]']) {
    let prefectureIds: any;
    if (route.query.prefectures) {
      prefectureIds = Array.isArray(route.query.prefectures)
        ? route.query.prefectures
        : [route.query.prefectures];
    } else {
      prefectureIds = Array.isArray(route.query['prefectures[]'])
        ? route.query['prefectures[]']
        : [route.query['prefectures[]']];
    }

    [...new Set(prefectureIds)].forEach((id) => {
      const prefecture = props.prefectures.find((prefecture) =>
        prefecture.children.some((child) => child.id.toString() == id)
      );
      if (prefecture) {
        const prefectureChild = prefecture.children.find((child) => child.id.toString() == id);
        const cities = [];

        if (route.query.city_ids || route.query['cities[]'] || route.query['cities']) {
          let cityIds: any;
          if (route.query.city_ids) {
            cityIds = Array.isArray(route.query.city_ids)
              ? route.query.city_ids
              : [route.query.city_ids];
          } else {
            cityIds = Array.isArray(route.query['cities[]'])
              ? route.query['cities[]']
              : [route.query['cities[]']];
          }

          cityIds.forEach((cityId) => {
            const matchingCity = [
              ...prefectureChild.main_cities,
              ...prefectureChild.extra_cities,
            ].find((city) => city.id.toString() == cityId);

            if (matchingCity) {
              cities.push(matchingCity);
            }
          });
        }

        valuesPrefectures.value.push({
          id: prefectureChild.id,
          name: prefectureChild.name,
          cities: cities,
        });
        prefectureSelected.value = cloneDeep(valuesPrefectures.value);
      }
    });
  }
};

const getOccupations = (): void => {
  if (route.query.job_types || route.query['job_types[]'] || route.query['job_types']) {
    let occupationIds: any;
    if (route.query.job_types) {
      occupationIds = Array.isArray(route.query.job_types)
        ? route.query.job_types
        : [route.query.job_types];
    } else {
      occupationIds = Array.isArray(route.query['job_types[]'])
        ? route.query['job_types[]']
        : [route.query['job_types[]']];
    }

    if (occupationIds) {
      occupationIds.forEach((id) => {
        props.occupations.forEach((occupation) => {
          const occupationChild = occupation.children.find((child) => child.id.toString() == id);

          if (occupationChild) {
            onChooseOccupation(occupation, occupationChild);
            occupationSelected.value = cloneDeep(valuesOccupations.value);
          }
        });
      });
    }
  }
};

const getAnnualIncome = (): void => {
  const minIncomeId = route.query.wage_min;
  const maxIncomeId = route.query.wage_max;

  const minIncome = props.incomes.find((income) => income.id.toString() == minIncomeId);
  const maxIncome = props.incomes.find((income) => income.id.toString() == maxIncomeId);

  if (minIncome) {
    minIncomeSelected.value = minIncome.id;
  }
  if (maxIncome) {
    maxIncomeSelected.value = maxIncome.id;
  }
};

const getIndustries = (): void => {
  if (route.query.industries || route.query['industries[]'] || route.query['industries']) {
    let industriesId: any;
    if (route.query.industries) {
      industriesId = Array.isArray(route.query.industries)
        ? route.query.industries
        : [route.query.industries];
    } else {
      industriesId = Array.isArray(route.query['industries[]'])
        ? route.query['industries[]']
        : [route.query['industries[]']];
    }

    if (industriesId) {
      industriesId.forEach((id) => {
        props.industries.forEach((industry) => {
          const industryChild = industry.children?.find((child) => child.id.toString() == id);

          if (industryChild) {
            onChooseIndustry(industry, industryChild);
            industriesSelected.value = cloneDeep(valuesIndustries.value);
          }
        });
      });
    }
  }
};

const getSkills = (): void => {
  if (route.query.skills || route.query['skills[]'] || route.query['skills']) {
    let skillIds: any;
    if (route.query.skills) {
      skillIds = Array.isArray(route.query.skills) ? route.query.skills : [route.query.skills];
    } else {
      skillIds = Array.isArray(route.query['skills[]'])
        ? route.query['skills[]']
        : [route.query['skills[]']];
    }

    skillIds.forEach((id) => {
      props.skills.forEach((skill) => {
        const skillChild = skill.children.find((child) => child.id.toString() == id);

        if (skillChild) {
          onChooseSkill(skill, skillChild);
          skillSelected.value = cloneDeep(valueSkills.value);
        }
      });
    });
  }
};

const getNumberIncome = (income: string): number | null => {
  const numberRegex = /\d+/;
  const match = income.match(numberRegex);

  if (match) {
    const number = parseInt(match[0], 10);
    return number;
  }
  return null;
};

defineExpose({
  onApplySearchCondition,
});
</script>
